import React from 'react'
import Switch from 'react-switch'
import { ToggleCompareEventStyle } from './styled'
import { default as VARIABLES } from '../../themes/styles/variables'
export const ToggleCompareEvent = ({
  handleTofuChange,
  checkedToggle,
  checkedIcon,
  uncheckedIcon,
}) => {
  const [checked, setChecked] = React.useState(false)
  const handleChange = nextChecked => {
    setChecked(nextChecked)
    handleTofuChange(nextChecked)
  }
  React.useEffect(() => {
    let mount = true
    if (mount) {
      setChecked(checkedToggle)
    }
    return () => {
      mount = false
    }
  }, [checkedToggle])
  return (
    <ToggleCompareEventStyle>
      <Switch
        onChange={handleChange}
        checked={checked}
        disabled={true}
        checkedIcon={checkedIcon}
        uncheckedIcon={uncheckedIcon}
        className="react-switch removeOpacity"
        handleDiameter={8}
        height={16}
        width={27}
        offColor={VARIABLES.COLORS.GRAY_5}
        onColor={VARIABLES.COLORS.GREEN_3}
      />
    </ToggleCompareEventStyle>
  )
}
ToggleCompareEvent.defaultProps = {
  handleTofuChange: () => {
    return false
  },
  checkedToggle: false,
  checkedIcon: false,
  uncheckedIcon: false,
}
